<template>
  <b-modal
    id="edit-receta-modal"
    v-model="localShowModalEdit"
    title="Editar Receta"
    @hide="onCloseModalEdit"
    ok-title="Guardar"
    @ok="onSubmitEdit"
    cancel-title="Cancelar"
    @cancel="onCloseModalEdit"
  >
    <b-form 
      @submit.prevent="onSubmitEditReceta"
      v-if="medicamento"
    >
      <b-form-group label-for="v-medicamentor">
        <v-select
          placeholder="Escribe el nombre del medicamento..."
          v-model="medicamentoForm.medicamento"
          :options="filteredMedicamentos"
          label="text"
          @search="onSearchMedicamentos"
          @input="onSelectMedicamento"
          :loading="isLoading"
          :debounce="300"
        >
          <template #no-options>
            {{ noMedicamentosMessage() }}
          </template>
        </v-select>
      </b-form-group>
      <b-form-group label="Cantidad" label-for="edit-cantidad">
        <b-form-input
          id="edit-cantidad"
          v-model="medicamentoForm.cantidad"
          type="number"
          min="0"
          required
        />
      </b-form-group>
      <b-form-group label="Dosis" label-for="edit-dosis">
        <b-row>
          <b-col cols="4">
            <b-form-input
              id="edit-dosis"
              v-model="medicamentoForm.dosisNumber"
              type="number"
              min="0"
              required
            />
          </b-col>
          <b-col cols="8">
            <v-select
              v-model="medicamentoForm.dosisTipo"
              :options="dosisOpts"
              :reduce="option => option"
              label="text"
              placeholder="Seleccione una opcion"
            />
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group label="Frecuencia" label-for="edit-frecuencia">

        <b-form-input
          id="edit-frecuencia"
          v-model="medicamentoForm.frecuencia"
          required
        />
      </b-form-group>
      <b-form-group label="Duración" label-for="edit-duracion">
        <b-form-input
          id="edit-duracion"
          v-model="medicamentoForm.duracion"
          required
        />
      </b-form-group>
      <b-form-group label="Observación" label-for="edit-observacion">
        <b-form-input
          id="edit-observacion"
          v-model="medicamentoForm.observacion"
          required
        />
      </b-form-group>
    </b-form>
  </b-modal>

</template>

<script>
import vSelect  from "vue-select";
import _ from "lodash";
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { mapState } from "vuex";
import { DOSIS_UNITS, formatDosis, parseDosis } from "@/shared/helpers";

export default {

  name: "MedicamentoModalEdit",

  components: {
    vSelect
  },

  props: {
    showModalEdit: {
      type: Boolean,
      default: false
    },

    medicamento: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    const dosisData = parseDosis(this.medicamento?.dosis);

    return {
      isLoading:false,
      filteredMedicamentos: [],
      searchQuery:"",
      dosisOpts: DOSIS_UNITS,

      medicamentoForm:{ ...this.medicamento, ...dosisData },
      
    }
  },

  created() {
    this.debouncedGetMedicamentos = _.debounce(this.obtenerMedicamentos, 300);
  },

  methods:{

    onSelectMedicamento(){
      if(!this.medicamentoForm.medicamento) return;
      
      const newMedicamento = this.medicamentoForm.medicamento; 
      this.medicamentoForm.medicamento   = newMedicamento.text;
      this.medicamentoForm.medicamentoID = newMedicamento.value;
    },

    async obtenerMedicamentos(search) {
      const idCita = this.$route.params.id; // Obtener el ID de la cita
      const establecimientoId = parseInt(
        await this.fetchGetEstablecimiento(idCita),
        10
      );

      if (search && establecimientoId !== -1) {
        try {
          const query = `
            query GetMedicamentos($search: String, $establecimiento: String) {
              allMedicamento(search: $search, establecimiento: $establecimiento) {
                id
                nombre
                numMax
              }
            }
          `;

          const response = await axios.post(rutas.axios + "api", {
            query,
            variables: {
              search: search,
              establecimiento: establecimientoId.toString(),
            },
          });

          this.filteredMedicamentos = response.data.data.allMedicamento.map(
            (item) => ({
              value   : item.id,
              text    : item.nombre,
              cantidad: item.numMax,
            })
          );
        } catch (error) {
          console.error("Error:", error.response ? error.response.data : error);
        }
      } else {
        this.filteredMedicamentos = [];
      }
    },


    async fetchGetEstablecimiento(idCita) {
      const query = `
        query qrgetCitaById($id: String!){
          getCitaId(idCit: $id) {
            cita {
              id
              fechaCita
              horaCita
              estado
              establecimiento{
                id
              }
            }  
          }
        }
      `;

      const varConsulta = { id: String(idCita), };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: varConsulta,
        });
        if (response.status === 200) {
          return response.data.data.getCitaId.cita[0].establecimiento.id;
        }
      } catch (error) {
        console.error("Error fetching establecimiento id:", error);
        return -1;
      }
    },


    onCloseModalEdit() {
      this.$emit('update:showModalEdit', false); 
    },


    onSubmitEdit() {
      if (
        !this.medicamentoForm.medicamento 
        || !this.medicamentoForm.cantidad 
        || !formatDosis(this.medicamentoForm.dosisNumber, this.medicamentoForm.dosisTipo)
        || !this.medicamentoForm.frecuencia 
        || !this.medicamentoForm.duracion 
        || !this.medicamentoForm.observacion
      ) {
        this.$swal({
          title: "Campos Incompletos",
          text: "Por favor, complete todos los campos requeridos antes de editar la receta.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;

      }

      const dosis = formatDosis(this.medicamentoForm.dosisNumber, this.medicamentoForm.dosisTipo);
      const medicamentoActualizado = {
        ...this.medicamentoForm,
        dosis,
      };

      const updateMedicamentosList = this.stMedicamentosList.map( 
        med  => ( med.id === this.medicamentoForm.id) 
          ? medicamentoActualizado
          : med
      );

      this.$store.commit("setMedicamentosList", updateMedicamentosList);


    },

    onSearchMedicamentos(search, loading) {
      if (search.length > 4) {
        this.isLoading = true;
        loading(true);
        this.searchQuery = search;
        this.debouncedGetMedicamentos(search);
      } else {
        this.filteredMedicamentos = [];
        this.isLoading = false;
      }
      loading(false);
    },


    noMedicamentosMessage() {
      if (this.searchQuery.length < 4) {
        return "Escribe más caracteres para buscar...";
      }
      if (this.isLoading) {
        return "Buscando medicamentos...";
      }
      if (this.searchFailed) {
        return "Error al buscar medicamentos. Intente de nuevo.";
      }
      if (this.filteredMedicamentos.length === 0 && !this.isLoading) {
        return "No se encontraron medicamentos que coincidan con tu búsqueda";
      }
      return "Escribe para buscar medicamentos...";
    },
  },


  computed: {

    ...mapState({
      stMedicamentosList: state => state.atencionCita.receta.medicamentosList,
    }),

    localShowModalEdit: {
      get() {
        return this.showModalEdit;
      },
      set(value) {
        this.$emit('update:showModalEdit', value);
      }
    }
  },

  watch: {
    medicamento:{
      deep: true,
      handler(newValue) {
        const dosisData = parseDosis(newValue?.dosis);
        this.medicamentoForm = {
          ...newValue,
          ...dosisData,
        };
      }
    }
  }

}
</script>
